import { FC } from 'react'
import tw from 'twin.macro'
import { ImageField } from '@prismicio/client'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Grid } from '../UI'
import Carousel from '../Carousel'

type Partner = { name: string; logo: ImageField }

type Props = {
  partners: Partner[]
}

const PartnerLogos: FC<Props> = ({ partners }) => {
  return (
    <section id="partner-logos" tw="bg-gb-cream h-[100px]">
      {/* Static version, hidden except lg */}
      <div tw="h-full hidden lg:(flex justify-center items-center)">
        {partners.map((partner, index) => {
          const isFirst = index === 0
          const isLast = index === partners.length - 1
          return (
            <GatsbyImage
              key={index}
              image={getImage(partner.logo)}
              css={[
                tw`h-10 w-[150px] mr-8`,
                !isFirst && tw`ml-8`,
                !isLast && tw`mr-8`,
              ]}
              imgStyle={{ objectFit: 'contain' }}
              alt={partner.name}
            />
          )
        })}
      </div>
      {/* Carousel version, hidden lg */}
      <Grid tw="block lg:hidden">
        <Carousel
          data={partners}
          ItemComponent={({ name, logo }: Partner) => (
            <div tw="h-[100px] flex items-center">
              <GatsbyImage
                image={getImage(logo)}
                tw="h-10 w-[150px] mx-2 md:mx-4"
                imgStyle={{ objectFit: 'contain' }}
                alt={name}
              />
            </div>
          )}
          cellAlign="left"
          controls="circular"
        />
      </Grid>
    </section>
  )
}

export default PartnerLogos
